import { LocationIcon } from 'icons/location-icon';
import { X } from 'lucide-react';
import React, { RefObject } from 'react';
import { useIntl } from 'react-intl';

import { SearchPopover } from '../v2/search-popover/index';

interface LocationInputProps {
  locationSearch: string;
  setLocationSearch: (value: string) => void;
  openLocationPopover: boolean;
  setOpenLocationPopover: React.Dispatch<React.SetStateAction<boolean>>;
  locationInputRef: RefObject<HTMLInputElement>;
  onClear: () => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onLocationSelect?: (id: string, value: string) => void;
  scrollToJobs: () => void;
  specialLocations: Array<{
    id: string;
    name: string;
    type: 'remote' | 'current';
    icon?: React.ReactNode;
    sublabel?: string;
  }>;
}

export function LocationInput({
  locationSearch,
  setLocationSearch,
  openLocationPopover,
  setOpenLocationPopover,
  locationInputRef,
  onClear,
  onKeyDown,
  onLocationSelect,
  scrollToJobs,
  specialLocations,
}: LocationInputProps) {
  const intl = useIntl();

  return (
    <div className="relative flex min-w-0 flex-1 items-center gap-2 border-r border-gray-300 px-3 py-3 sm:gap-3 sm:px-4 lg:w-[311px] lg:flex-none">
      <LocationIcon />
      <input
        ref={locationInputRef}
        placeholder={intl.formatMessage({
          defaultMessage: 'Search by location',
          description: 'Placeholder for location search input',
        })}
        onChange={e => {
          setLocationSearch(e.target.value);
          if (!openLocationPopover) {
            setOpenLocationPopover(true);
          }
        }}
        onClick={() => {
          setOpenLocationPopover(true);
        }}
        onFocus={() => {
          setOpenLocationPopover(true);
        }}
        onKeyDown={onKeyDown}
        className="min-w-0 flex-1 truncate border-none outline-none"
        value={locationSearch}
      />
      {locationSearch && (
        <button
          type="button"
          onClick={onClear}
          className="flex h-5 w-5 items-center justify-center rounded-full bg-gray-200 text-gray-500 hover:bg-gray-300 hover:text-gray-700"
        >
          <X className="h-3 w-3" />
        </button>
      )}

      {/* Location Popover - Inside location input container */}
      {openLocationPopover && (
        <SearchPopover
          searchString={locationSearch}
          setOpenPopover={setOpenLocationPopover}
          scrollToJobs={scrollToJobs}
          setInputText={setLocationSearch}
          filterTypes={['locations']}
          showSectionHeaders={false}
          onLocationSelect={onLocationSelect}
          specialLocations={specialLocations}
          ignoreClickOutsideElements={[locationInputRef]}
        />
      )}
    </div>
  );
}
